export default [
    {
      path: "/user/edit",
      name: "user.edit",
      meta: {
        title: "个人中心",
      },
      component: () => import("./UserEdit"),
    },
    {
        path: '/user/evaluate',
        name: 'user.evaluate',
        meta: {
            title: '商品评价'
        },
        component: () => import('./UserEva')
    },
    {
        path: '/user/collect',
        name: 'user.collect',
        meta: {
            title: '商品收藏'
        },
        component: () => import('./UserCollect')
    },
    {
        path: '/user/customer',
        name: 'user.customer',
        meta: {
            title: '联系客服'
        },
        component: () => import('./Customer')
    }
];